import React, { useEffect, useState } from 'react'
import * as PropTypes from 'prop-types'
import { Collapse as ReactCollapse } from 'react-collapse'
import noop from 'utils/noop'

const Collapse = ({ children, isOpened, onRest, ...props }) => {
  const [open, setOpen] = useState(isOpened)
  const [innerDisplay, setInnerDisplay] = useState(() => {
    return isOpened ? 'block' : 'none'
  })

  useEffect(() => {
    if (isOpened) {
      setInnerDisplay('block')
    }
    setOpen(isOpened)
  }, [isOpened])

  const handleRest = (p = {}) => {
    const { isFullyClosed } = p
    if (isFullyClosed) {
      setInnerDisplay('none')
    }
    onRest(p)
  }
  return (
    <ReactCollapse onRest={handleRest} isOpened={open} {...props}>
      <div style={{ display: innerDisplay }}>{children}</div>
    </ReactCollapse>
  )
}

Collapse.propTypes = {
  children: PropTypes.node.isRequired,
  isOpened: PropTypes.bool.isRequired,
  onRest: PropTypes.func,
}

Collapse.defaultProps = {
  onRest: noop,
}

export default Collapse
